import React, { useState } from "react";
import "../styles/TestimonialsFaqFooter.css";
import Footer from "./footer";


function TestimonialsFaqFooter() {
    const [openFaq, setOpenFaq] = useState(null);

    const testimonials = [
        {
            name: "Tushar Pal",
            location: "Mumbai",
            rating: 5.0,
            text: "Easy to use, professional service, and genuine advice. Highly recommend."
        },
        {
            name: "Manish Kumar",
            location: "Pune",
            rating: 4.9,
            text: "Niveshly made buying unlisted share easy. The process was quick, secure and Transperent."
        },
        {
            name: "Tarang Chawla",
            location: "Bengaluru",
            rating: 5,
            text: "People with great knowledge."
        },

        {
            name: "Priya Mehta.",
            location: "Chennai",
            rating: 4.7,
            text: "Niveshly is not just another platform; it’s a partner in financial growth. The personalized suggestions and easy-to-use dashboard helped me plan for my family’s future in a structured way. I truly feel more financially secure"
        },
        {
            name: "Nikint Dev",
            location: "Delhi",
            rating: 4.9,
            text: "Easy to use..☺️🙏"
        },
        {
            name: "Amit Verma",
            location: "Hyderabad",
            rating: 4.0,
            text: "What I love about Niveshly is the clarity and honesty. No hidden charges, no complicated jargon—just simple, effective investment solutions. Their team actually listens and provides guidance suited to my goals"
        }
    ];

    const faqs = [
        {
            question: "What documents are required to buy/sell unlisted shares?",
            answer: "You'll need PAN card, Aadhaar card, bank account details, and demat account information. We'll guide you through the entire documentation process to ensure a smooth transaction."
        },
        {
            question: "Can I hold unlisted shares in my demat account?",
            answer: "Yes, unlisted shares can be held in your demat account. Once the transfer is complete, the shares will reflect in your demat account just like listed securities."
        },
        {
            question: "What is the minimum investment amount in unlisted shares?",
            answer: "The minimum investment varies by company. Typically, it ranges from ₹25,000 to ₹1,00,000 depending on the share price and minimum lot size set by the company."
        },
        {
            question: "Are unlisted shares risky to invest in?",
            answer: "Like all investments, unlisted shares carry risk. However, they offer high growth potential for companies pre-IPO. We recommend diversifying your portfolio and investing only what you can afford to hold long-term."
        },
        {
            question: "How long should I hold unlisted shares?",
            answer: "We recommend holding unlisted shares for 2-5 years to maximize returns, especially if you're waiting for an IPO. Long-term holding typically yields better results as companies mature and go public."
        },
        {
            question: "How can I track the performance of my unlisted shares?",
            answer: "Our platform provides real-time updates on your holdings. You'll receive notifications about company updates, valuation changes, and any IPO announcements to keep you informed."
        },
        {
            question: "What happens to my unlisted shares if the company gets listed?",
            answer: "When a company goes public, your unlisted shares automatically convert to listed shares at the IPO price. You can then trade them on stock exchanges like any other listed security."
        }
    ];

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    return (
        <div className="testimonials-faq-footer">
            {/* Testimonials Section */}
            <section className="testimonials-section">
                <div className="testimonials-header">
                    <h2 className="section-title-investor">What Our Investors Say</h2>
                    <p className="section-subtitle">
                        Real stories from investors growing their wealth with unlisted shares.
                    </p>
                </div>

                <div className="testimonials-grid">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-header">
                                <h4 className="testimonial-name">{testimonial.name}</h4>
                                <div className="testimonial-rating">
                                    <span className="star">⭐</span>
                                    <span className="rating-value">{testimonial.rating}</span>
                                </div>
                            </div>
                            <p className="testimonial-text">{testimonial.text}</p>
                            <p className="testimonial-location">{testimonial.location}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="faq-header">
                    <h2 className="section-title-light">Frequently Asked Questions</h2>
                    <p className="section-subtitle-light">
                        Everything you need to know about investing in unlisted shares
                    </p>
                </div>

                <div className="faq-container">
                    {faqs.map((faq, index) => (
                        <div key={index} className={`faq-item ${openFaq === index ? "active" : ""}`}>
                            <button className="faq-question" onClick={() => toggleFaq(index)}>
                                <span>{faq.question}</span>
                                <span className="faq-icon">{openFaq === index ? "−" : "+"}</span>
                            </button>
                            {openFaq === index && (
                                <div className="faq-answer">
                                    <p>{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>
            <div>
                <Footer />
            </div>

        </div>
    );
}

export default TestimonialsFaqFooter;